export const classNames = {
  gridHeaderWithFloatingFilter: 'grid-header-with-floating-filter',
  gridCustomColumnHeader: 'grid-custom-column-header',
}
